import React, { useContext } from 'react';
import styled from 'styled-components';

import { ApplicationUIContext, colors } from '@yuhuinc/ui-library';
import { Typography, Menu, Divider, Space, Spin } from 'antd';

import { getTranslatedString } from 'helpers/i18n';
import { CurrentApplicationContext } from '../../ApplicationOverview';

const { Title, Text } = Typography;

const Container = styled(Space)`
  width: 295px;
  min-width: 295px;
  border: ${(props) => `1px solid ${colors.colors.neutral[5]}`};
  background: ${colors.colors.white[1]};

  > .ant-space-item:first-child > .ant-typography {
    margin: 0;
    padding: 16px;
  }

  > .ant-space-item-split > .ant-divider-horizontal {
    margin: 0;
  }

  .ant-menu-vertical {
    border: none;
  }

  .ant-menu-item {
    height: auto;
    line-height: normal;
    padding: 8px 16px;
  }

  .ant-menu-title-content .ant-typography {
    color: inherit;
  }
`;

const translate = (key) =>
  getTranslatedString(`landlordPortal.applicationManagement.leaseOverview.${key}`);

const PeopleSelector = ({ selectedApplicantId, setSelectedApplicantId }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const currentApplication = useContext(CurrentApplicationContext);

  const applicants = currentApplication?.applicants || [];

  if (!applicants) {
    return <Spin />;
  }

  return (
    <Container direction="vertical" split={<Divider />}>
      <Title level={isMobile ? 4 : 5}>{translate('people.cardTitle')}</Title>
      <Menu
        selectedKeys={[selectedApplicantId]}
        onClick={({ key }) => setSelectedApplicantId(key)}
        items={applicants.map((applicant) => ({
          key: applicant.custom_id,
          label: (
            <Space direction="vertical" size={2}>
              <Text style={{ fontSize: 16 }}>{applicant.full_name}</Text>
              <Text>
                {getTranslatedString(
                  `landlordPortal.applicationManagement.applicationOverview.overview.applicants.applicantTypes.${applicant.applicant_type}`
                )}
              </Text>
            </Space>
          ),
        }))}
      />
    </Container>
  );
};

export default PeopleSelector;
